import React from 'react';
import TextEditor from "../../A13/DynaView/TextEditor/TextEditor";

function Editor({row, onChange, myData}) {

  try {
    return <TextEditor onChange={onChange} myData={myData} row={row}/>
  } catch (error) {
    return <>{error.toString()}</>
  }
}

export default React.memo(Editor);